import { useSessionExpiry } from './useSessionExpiry';
import { SessionExpiryModal } from './SessionExpiryModal';

/**
 * Mounts the idle-session machinery once for the whole app — slice-3560 (ADR-0046).
 *
 * <p>Rendered by `App` only when there is a session and the route is not `/login`: the
 * countdown must never leak into an unauthenticated state (design doc §5.4), and the hook's
 * timers have nothing to guard there anyway.
 */
export function SessionGuard() {
  const { warning, secondsLeft, idleMinutes, renewing, keepWorking, signOutNow } =
    useSessionExpiry();
  return (
    <SessionExpiryModal
      open={warning}
      secondsLeft={secondsLeft}
      idleMinutes={idleMinutes}
      renewing={renewing}
      onKeepWorking={keepWorking}
      onSignOut={signOutNow}
    />
  );
}
